












































































import Vue from "vue";
import Shared from "../../../shared";
import Utils from "../../../utils";
import UserAvatar from "../../buttons/UserAvatar.vue";

export default Vue.extend({
    name: "UserMenu",
    components: { UserAvatar },
    props: {
        openPrivacy: { type: Function, required: true },
        portalId: Number,
        showLogoff: { type: Boolean, default: false },
        showMyControlTests: { type: Boolean, default: false },
        showMyControlTestReviews: { type: Boolean, default: false },
        showMyFindings: { type: Boolean, default: false },
        showApps: { type: Boolean, default: false }
    },
    computed: {
        isInternetExplorer(): Boolean {
            return Utils.isIE11;
        },
        isAnonymousUser(): Boolean {
            return Utils.isAnonymousUser(this.$user.user_id);
        },
        userFullName(): string {
            return this.$user?.name;
        },
        userLoginCode(): string {
            return this.$user?.login_code;
        },
        isAutoLogon(): boolean {
            return Utils.getCookie("AutomaticallyLoggedIn") == "1";
        },
        showMySettings(): boolean {
            return this.$user.show_preferences;
        },
        showMySubscriptions(): boolean {
            return this.$user.show_tasks_and_subscriptions;
        }
    },
    methods: {
        privacyClicked() {
            this.openPrivacy();
        },
        logOnClicked() {
            Utils.navigateToLogin();
        },
        logoffClicked() {
            location.href = `${Shared.iProvaUrl}/Management/Login/Logoff.aspx`;
        },
        logOnAsDifferentUserClicked() {
            Utils.navigateToLogin(location.href, true);
        },
        gotoMyControlTests() {
            location.href = `${Shared.iProvaUrl}/Risk/#/control-tests`;
        },
        gotoMyControlTestReviews() {
            location.href = `${Shared.iProvaUrl}/Risk/#/control-test-reviews`;
        },
        gotoMyFindings() {
            location.href = `${Shared.iProvaUrl}/Audit/#/findings`;
        }
    }
});
